import React, { forwardRef, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { Link as RouterLink } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { TextField, IconButton, Tabs, Tab } from "@mui/material";
import Box from "@mui/material/Box";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import QuotationDocs from "./QuotationDocs";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import RelatedDocs from "./RelatedDocs";
import ImageModal from "./ImageModal";
import { useBreadcrumbs } from "./BreadcrumbsContext";
import SaleTab from "../tabs/SaleTab";
import CustomerDetailsTab from "../tabs/CustomerDetailsTab";
import { OtherDetailsTab } from "../tabs/OtherDetailsTab";
import { HistoryDetailsTab } from "../tabs/HistoryDetailsTab";
import { Switch, FormControlLabel } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import ProductsInQuotation from "../components/lead_and_quotation/ProductsInQuotation";
import { format } from "date-fns";
import UnifiedSaleTab from "../tabs/UnifiedSalesTab";
import SalesTab from "../tabs/UnifiedSalesTab";

const QuotationComponent = ({ productDetails, onClose }) => {
  let company_code_from_local_storage = localStorage.getItem("companyCode")
    ? localStorage.getItem("companyCode")
    : "-";
  let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";

  const [typedProjectNameFromChild, setTypedProjectNameFromChild] =
    useState("");

  const [typedAccountFromChild, setTypedAccountFromChild] = useState(null);

  const [typedCustomerNameFromChild, setTypedCustomerNameFromChild] =
    useState(null);

  const [isCallingTemplateListApi, setIsCallingTemplateListApi] =
    useState(false);

  const [isCallingAddToTemplateListApi, setIsCallingAddToTemplateListApi] =
    useState(false);
  const [showHideTemplateList, setShowHideTemplateList] = useState(false);
  const [termsTemplatelist, setTermsTemplatelist] = useState(null);
  const [showAddToTemplateForm, setShowAddToTemplateForm] = useState(false);
  const [templatename, setTemplateName] = useState("");

  let sunrise_payment_terms = `1. Scope of Work : Supply Only 
    2. Validity: This quotation is valid for 15 days. 
   3. Delivery Time: Subjected to availability of stock at time of confirmation, else 6-8 weeks from the date of advance Payment
   4. Payment Terms: Cash
  Payment should be made in favor of “SUNRISE OASIS LIGHTING LLC"
  Bank Name: RAK BANK ; Account No: 0003-216105-061 
  IBAN :AE800400000003216105061 
  
  Warranty Terms
  1. Manufacturer standard warranty on manufacturing defects under standard warranty conditions.
  2. Warranty against the manufacturing defect from the date of invoice.
  3. The warranty claim is subject to in house warranty only, for there modification or repair at the site will not cover the same and will be chargeable.
  `;
  let initialPaymentString =
    company_code_from_local_storage?.trim().toUpperCase() === "SUNRISE"
      ? sunrise_payment_terms
      : "";

  const [paymentState, setPaymentState] = useState(initialPaymentString);

  const [currentF2ItemForSearchPopup, setCurrentF2ItemForSearchPopup] =
    useState(0);
  const [nextActionArrayInParent, setNextActionArrayInParent] = useState(null);

  useEffect(() => {
    console.log("nextActionArrayInParent", nextActionArrayInParent);
  }, [nextActionArrayInParent]);

  const [vat, setVat] = useState("");

  const currentSelectedDepartment = localStorage.getItem(
    "currentSelectedDepartment"
  );

  const [quotationNumberOfThisLead, setQuotationNumberOfThisLead] =
    useState(null);
  const [discountValue, setDiscountValue] = useState(0);

  const loc = useLocation();
  const selectedLead = loc.state?.selectedLead;
  console.log("selectedLead in quoteleadAdmin", selectedLead);

  const { setShowBreadcrumbs } = useBreadcrumbs();
  const navigate = useNavigate();
  const apiRef = useGridApiRef();

  const [selectedTab1, setSelectedTab1] = useState(0);
  const [selectedTab2, setSelectedTab2] = useState(0);
  const [productsInQuotationState, setProductsInQuotation] = useState(null);
  const [duplicateItemCodeSnackbar, setDuplicateItemCodeSnackbar] =
    useState(false);
  const [products, setProducts] = useState(productDetails);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [modalImage, setModalImage] = useState("");
  const [vatIncluded, setVatIncluded] = useState(false);
  const [vatValue, setVatValue] = useState("");
  const [productData, setProductData] = useState([]);
  const [selectedPromisedDate, setSelectedPromisedDate] = useState("");
  const [selectedFollowupDate, setSelectedFollowupDate] = useState("");
  const [currency, setCurrency] = useState("AED");
  const [currencyAmount, setCurrencyAmount] = useState("");
  const [isSubmittingForm, setIsSubmittingForm] = useState(false);
  const [currentProductEntryRowId, setCurrentProductEntryRowId] =
    useState(null);
  const [currentProductTyping, setCurrentProductTyping] = useState(null);
  const [openSubmitSnackbar, setOpenSubmitSnackbar] = useState(false);
  const [productEntries, setProductEntries] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [errorRow, setErrorRow] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [customerSubject, setCustomerSubject] = useState(null);
  const [customerTRN, setCustomerTRN] = useState(null);
  const [customerType, setCustomerType] = useState("registered");
  const [showPDFDialogBox, setShowPDFDialogBox] = useState(false);
  const [userDepartment, setUserDepartment] = useState(null);
  const handleCustomerTypeChange = (newCustomerType) => {
    setCustomerType(newCustomerType);
  };
  // console.log("customerType:::", customerType);

  useEffect(() => {
    setUserDepartment(localStorage.getItem("currentSelectedDepartment"));
  }, []);

  useEffect(() => {
    console.log("vatValue after calculation", vatValue);
  }, [vatValue]);

  // console.log("userDepartment", userDepartment);

  const getAlreadySendQuotation = async (quotationNumber) => {
    console.log("getAlreadySendQuotation in Admin ", quotationNumber);

    return new Promise((resolve, reject) => {
      let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/Proposal/${company_code_from_local_storage}/QUOTEDETAILS/${quotationNumber}/${currentSelectedDepartment}`;
      console.log("apiurl of get quotationdetails in Admin", apiUrl);

      axios
        .get(apiUrl)
        .then((res) => {
          if (res.data) {
            console.log(
              "result of quotation details ",
              res.data,
              new Date().getTime()
            );

            let productListFromAlreadySendQuotation = res.data.map(
              (item, index) => {
                return {
                  id: new Date().getTime() + index,
                  isSelectedItemCodeCorrect: true,
                  itemCode: item.so_icode,
                  itemDescription: item.idesc,
                  itemUnit: item.unit,
                  itemQuantity: item.tr_qty2,
                  itemPrice: item.so_fccost,
                  itemAmount: item.tr_qty2 * item.so_fccost,
                  itemCurrentStock: "",
                  itemImage: item.Imagepath,
                  itemImageBase64: item.Imagebase64,
                  itemWebLink: item.WebLink,
                  area_code: item.area_code,
                  quotation_number: item.so_no,
                  revision_number: item.jv_num,
                  foot1: item.foot1,
                  head1: item.head1,
                  payment: item.payment,
                  salespersonName: item.salespersonName,
                  Coordinator: item.Coordinator,
                  so_disc: item.so_disc,
                  so_doc: item.so_doc,
                  Lead_Phone: item.Lead_Phone,
                  Lead_email: item.Lead_email,
                  lead_CampaignId: item.lead_campaignid,
                  lead_CoordinatorName: item.lead_CoordinatorName,
                  customer_name_from_details: item.accdesc,
                  customer_account_from_details: item.cust_acc,
                  itemCustRef: item.Cust_Ref ? item.Cust_Ref : item.size,
                  project_name_from_details: item.so_doc,
                };
              }
            );

            if (productListFromAlreadySendQuotation) {
              if (productListFromAlreadySendQuotation.length > 0) {
                console.log(
                  "parseFloat( productListFromAlreadySendQuotation[0].foot1 ) ",
                  productListFromAlreadySendQuotation[0],
                  parseFloat(productListFromAlreadySendQuotation[0].foot1)
                );

                if (
                  parseFloat(productListFromAlreadySendQuotation[0].foot1) > 0
                ) {
                  setVat("vatApplied");
                } else {
                  console.log("inside vatExempted");
                  setVat("vatExempted");
                }

                if (productListFromAlreadySendQuotation[0].so_disc) {
                  console.log(
                    "productListFromAlreadySendQuotation[0].so_disc ",
                    productListFromAlreadySendQuotation[0].so_disc
                  );
                  setDiscountValue(
                    productListFromAlreadySendQuotation[0].so_disc
                  );
                }

                if (productListFromAlreadySendQuotation[0].payment) {
                  setPaymentState(
                    productListFromAlreadySendQuotation[0].payment
                  );
                }
              }
            }

            setProductsInQuotation(productListFromAlreadySendQuotation);
          }
        })
        .catch((err) => {
          console.log("err ", err);
        });
    });
  };

  const checkingForQuotation = async (selectedLeadFromUseEffect) => {
    console.log("selectedLeadFromUseEffect ", selectedLeadFromUseEffect);
    try {
      setQuotationNumberOfThisLead(selectedLeadFromUseEffect);

      getAlreadySendQuotation(selectedLeadFromUseEffect);
    } catch (err) {
      console.log("res Column1 rejected reason", err);
    }
  };

  useEffect(() => {
    console.log("inside useEffect QuoteleadAdmin", selectedLead);

    if (selectedLead) {
      checkingForQuotation(selectedLead.Prop_No);
    }
  }, [selectedLead]);

  const handleImageClick = (rowId) => {
    const selectedProduct = products.find((product) => product.id === rowId);
    if (selectedProduct.image) {
      setModalImage(selectedProduct.image); // Set the image to display.
      setOpenModal(true);
    } else {
      const fileInput = document.getElementById(`file-upload-${rowId}`);
      if (fileInput) {
        fileInput.click(); // Trigger file input dialog.
      }
    }
  };

  const handleImageUpload = (event, rowId) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file); // Generate a preview URL.
      setProducts((prev) =>
        prev.map((product) =>
          product.id === rowId ? { ...product, image: imageUrl } : product
        )
      );
    }
  };

  const leadItems = selectedLead?.leadIsItemAdded
    ? [
        {
          id: selectedLead.leadItemCode || `row-1`,
          leadItemCode: selectedLead.leadItemCode || "N/A",
          leadItemDescription: selectedLead.leadItemDescription || "N/A",
          leadItemUnit: selectedLead.leadItemUnit || "N/A",
          leadItemVatPercentage: selectedLead.leadItemVatPercentage || "0%",
          leadItemVatAmount: selectedLead.leadItemVatAmount || "0.00",
          image: selectedLead.image || "",
          leadItemCurrentStock: selectedLead.leadItemCurrentStock || "0",
          leadItemQuantity: selectedLead.leadItemQuantity || "0",
          leadItemFraction: selectedLead.leadItemFraction || "0",
          leadItemPrice: selectedLead.leadItemPrice || "0.00",
          leadItemDiscount: selectedLead.leadItemDiscount || "0%",
          leadItemAmount: selectedLead.leadItemAmount || "0.00",
          leadItemType: selectedLead.leadItemType || "N/A",
        },
      ]
    : [];

  const handleTab1Change = (event, newValue) => {
    setSelectedTab1(newValue);
  };

  const handleTab2Change = (event, newValue) => {
    setSelectedTab2(newValue);
  };

  const handleRowSelection = (ids) => {
    setSelectedRows(ids);
  };

  const togglePopup = () => {
    // setIsPopupOpen(!isPopupOpen);
    // onClose();
    // console.log("Save Quotation Data");
  };

  const handleRedirect = () => {
    setShowBreadcrumbs(false);
    navigate("/qualifiedLeadsTable"); // Redirect to Qualified Leads
  };

  const handlePromisedDateChange = (event) => {
    setSelectedPromisedDate(event.target.value); // Update the state with the new date
  };

  const handleFollowupDateChange = (event) => {
    setSelectedFollowupDate(event.target.value); // Update the state with the new date
  };

  const location = useLocation();
  const selectedQuotationDate = location.state?.formattedDate || "";
  const isQuotationRoute = location.pathname.includes("quoteLeadAdmin");

  // Handle toggle switch
  const handleToggle = (event) => {
    console.log(
      "event.target.checked handleToggle event, vatFromSaleTab",
      event.target.checked,
      vat
    );

    if (vat === "vatApplied" || vat === "noVat") {
      console.log(
        "event.target.checked handleToggle if >>>++>>>",
        event.target.checked,
        vat
      );
    } else {
      console.log(
        "event.target.checked handleToggle else",
        event.target.checked
      );

      setVatIncluded(event.target.checked);

      if (event.target.checked) {
        console.log(
          "event.target.checked handleToggle else >>> again if productsInQuotationState",
          event.target.checked,
          productsInQuotationState,
          discountValue
        );

        if (discountValue) {
          console.log("setvatvalue 1");
          setVatValue(
            (productsInQuotationState
              ?.filter((item) => {
                if (item.itemCustRef === "OPT" || item.itemCustRef === "OPTION") {
                  return false;
                } else {
                  return true;
                }
              })
              .reduce((acc, curr) => {
                return acc + curr.itemQuantity * curr.itemPrice;
              }, 0) -
              discountValue) *
              0.05
          );
        } else {
          console.log("setvatvalue 2");
          setVatValue(
            productsInQuotationState
              ?.filter((item) => {
                if (item.itemCustRef === "OPT" || item.itemCustRef === "OPTION") {
                  return false;
                } else {
                  return true;
                }
              })
              .reduce((acc, curr) => {
                return acc + curr.itemQuantity * curr.itemPrice;
              }, 0) * 0.05
          );
        }
      } else {
        console.log(
          "event.target.checked handleToggle else >>> again else",
          event.target.checked
        );

        console.log("setvatvalue 3");
        setVatValue(0);
      }
    }
  };

  const handleCurrency = (event) => {
    setCurrency(event.target.value);
  };

  const handleCurrencyAmount = (event) => {
    setCurrencyAmount(event.target.value);
  };

  const theme = createTheme({
    typography: {
      fontFamily: `'Figtree', sans-serif`,
    },
  });

  const handleDownloadPDF = () => {
    const quotationElement = document.getElementById("quotation-content");

    html2canvas(quotationElement, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 10, imgWidth, imgHeight);
      pdf.save("quotation.pdf");
    });
  };

  const handleSaveQuotation = async () => {
    console.log(
      "productsInQuotationState[0]]]]]--> handle",
      productsInQuotationState[0]
    );

    if (customerType === "registered") {
      if (typedAccountFromChild === "00000000") {
        alert("please search and select registered customer ");
        return;
      }
    } else {
      if (typedCustomerNameFromChild?.length === 0) {
        alert("please type customer/organization name");
        return;
      }
    }

    console.log(
      "productsInQuotationState[0]]]]]-->",
      productsInQuotationState[0]
    );

    const requestData = productsInQuotationState.map((product, index) => ({
      cmpcode: company_code_from_local_storage,
      opmode: quotationNumberOfThisLead ? "EDIT" : "SAVE",
      so_no: quotationNumberOfThisLead ? quotationNumberOfThisLead : "NEW",
      so_date: format(new Date(), "yyyy-MM-dd'T'hh:mm:ss"),
      Cust_Acc: typedAccountFromChild
        ? typedAccountFromChild
        : selectedLead.lead_account,
      jv_num: "0",
      comments: "",
      sale_man: selectedLead.lead_salesperson,
      inv_no: "0",
      so_status: "",
      // area_code: "AC1001",
      area_code: productsInQuotationState
        ? productsInQuotationState[0].area_code
          ? productsInQuotationState[0].area_code
          : "Draft"
        : "Draft", // Approval stage of
      so_ref: "REF98765",
      so_doc: typedProjectNameFromChild,
      fc: "AED",
      // so_amount means last amount after discount and vat for example 17.85 ,, 20 - 3 = 17 5% of 17 0.85 so 17 + .85
      so_amount:
        productsInQuotationState
          ?.filter((item) => {
            if (item.itemCustRef === "OPT" || item.itemCustRef === "OPTION") {
              return false;
            } else {
              return true;
            }
          })
          .reduce((acc, curr) => {
            if (curr.Lead_ID) {
              return acc + curr.Prod_Qty * curr.Prod_Price;
            } else {
              return acc + curr.itemQuantity * curr.itemPrice;
            }
          }, 0) -
        discountValue +
        vatValue +
        "",
      so_fcamt: 0,
      so_fcrate: 1,
      so_disc: discountValue ? discountValue : 0,
      due_date: "2025-03-15T00:00:00", // dummy value
      so_fdisc: 0.0,
      accdesc: typedCustomerNameFromChild
        ? typedCustomerNameFromChild
        : selectedLead.lead_organization,
      head1: productsInQuotationState
        ? productsInQuotationState[0]?.head1
        : "-", // missing
      subject: customerSubject,
      foot1: vatValue ? vatValue + "" : 0 + "",
      payment: paymentState,
      delivery: "",
      validity: "",
      deptno: currentSelectedDepartment,
      ESTI_NO: selectedLead.lead_id,
      quot_NO: 0 + "",
      ord_NO: 0 + "",
      remarks: "",
      c1: selectedLead.lead_coordinator,
      c2: customerTRN ? customerTRN : "-",
      c3: "",
      cash_customer: customerType === "registered" ? "No" : "Yes",
      cash_customer_company_address:
        customerType === "registered"
          ? ""
          : `${selectedLead?.lead_streetaddress || ""} ${
              selectedLead?.lead_territory || ""
            } ${selectedLead?.lead_country || ""} ${
              selectedLead?.lead_city || ""
            } ${selectedLead?.lead_appartment || ""} ${
              selectedLead?.lead_area || ""
            } ${selectedLead?.lead_location || ""}`,
      cash_customer_company_name:
        customerType === "registered" ? "" : selectedLead?.lead_organization,
      cash_customer_company_phone_number:
        customerType === "registered"
          ? ""
          : selectedLead?.lead_phone
          ? selectedLead?.lead_phone
          : productsInQuotationState[0].Lead_Phone
          ? productsInQuotationState[0].Lead_Phone
          : "",

      // Slno: "1",
      Slno: index + 1,
      // code: "PRD98765",
      code: product.Prod_code ? product.Prod_code : product.itemCode,
      // description: "Product Description Here",
      description: product.Prod_code
        ? product.Prod_Description
        : product.itemDescription,
      locn: "",
      // unit: "PCS",
      unit: product.Prod_code ? product.Prod_Unit : product.itemUnit,

      qty: product.Prod_code ? product.Prod_Qty + "" : product.itemQuantity,
      unit_price: product.Prod_code
        ? product.Prod_Price + ""
        : product.itemPrice + "",
      "disc%": 0,
      BlkPrice: 0, // dummy
      Amount:
        productsInQuotationState
          ?.filter((item) => {
            if (item.itemCustRef === "OPT" || item.itemCustRef === "OPTION") {
              return false;
            } else {
              return true;
            }
          })
          .reduce((acc, curr) => {
            if (curr.Lead_ID) {
              return acc + curr.Prod_Qty * curr.Prod_Price;
            } else {
              return acc + curr.itemQuantity * curr.itemPrice;
            }
          }, 0) -
        discountValue +
        vatValue +
        "", // now pass so_amount here also as manoj sir said because in backend this field not considered
      x: "",
      cntrl: "",
      fraction: 1,
      "vat%": vatValue ? 5 : 0,
      Vatamt: vatValue ? vatValue + "" : 0 + "",
      total:
        productsInQuotationState
          ?.filter((item) => {
            if (item.itemCustRef === "OPT" || item.itemCustRef === "OPTION") {
              return false;
            } else {
              return true;
            }
          })
          .reduce((acc, curr) => {
            if (curr.Lead_ID) {
              return acc + curr.Prod_Qty * curr.Prod_Price;
            } else {
              return acc + curr.itemQuantity * curr.itemPrice;
            }
          }, 0) -
        discountValue +
        vatValue +
        "", // here also pass same as so_amount as manoj sir said because this field not considered
      oem: "",
      UPrice_VIncl: 0 + "",
      item_Remarks: product.itemCustRef ? product.itemCustRef : "",
    }));

    console.log(" requestData save quotation ", requestData);
    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/Proposal`; // Replace with your API URL

    try {
      console.log("Request Data:", requestData); // Debug the request payload
      const response = await axios.post(apiUrl, requestData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("API Response:", response.data);
      // alert("Order Saved Successfully");
      popupPDF();
    } catch (error) {
      console.error("Error Sending API:", error);
      alert("Failed to Save Order");
    }
  };

  const popupPDF = () => {
    setShowPDFDialogBox(true);
  };

  // console.log("showPDFDialogBox::", showPDFDialogBox);

  const navigateToPDF = () => {
    // send api , if success open popup for view in pdf ? and then navigate to pdf

    console.log("selectedLead inside navigate to pdf ", selectedLead);

    if (selectedLead) {
      navigate("/quotationPage", {
        state: {
          selectedLead,
          productsInQuotationState,
          vatValue,
          discountValue,
        },
      });
    } else {
      navigate("/quotationPage");
    }
  };

  const onQuotationList = () => {
    navigate("/quotationsListViewFull");
  };

  const defaultRow = {
    id: Date.now(),
    itemCode: "",
    itemDescription: "",
    itemUnit: "",
    itemCurrentStock: "",
    itemQuantity: "",
    itemPrice: "",
    itemAmount: "",
    isSelectedItemCodeCorrect: false,
  };

  const handleAddRow = (e) => {
    e.preventDefault();
    console.log("handle add row clicked in quotelead");

    if (productsInQuotationState) {
      const newRow = {
        id: Date.now(),
        itemCode: "",
        itemDescription: "",
        itemImage: "",
        itemUnit: "",
        itemCurrentStock: "",
        itemQuantity: "",
        itemPrice: "",
        itemAmount: "",
        isSelectedItemCodeCorrect: false,
      };

      setProductsInQuotation((prevEntries) => [...prevEntries, newRow]);
    } else {
      const newRow = {
        id: Date.now(),
        itemCode: "",
        itemDescription: "",
        itemImage: "",
        itemUnit: "",
        itemCurrentStock: "",
        itemQuantity: "",
        itemPrice: "",
        itemAmount: "",
        isSelectedItemCodeCorrect: false,
      };

      setProductsInQuotation([newRow]);
    }
  };

  const handleInputChange = (id, field, value) => {
    setCurrentProductEntryRowId(id);

    console.log(
      "handleInputChange row id productsInQuotationState",
      id,
      field,
      productsInQuotationState
    );

    // Set the current value being typed
    setCurrentProductTyping(value);
    if (field === "itemCode") {
      console.log("itemcode is set");
      fetchItemDetails(value, id); // Call your fetch function for item details
    }

    // Update the productEntries state with the new value
    let newArray = productsInQuotationState?.map((item) => {
      if (item.Lead_ID) {
        if (item.Prod_code === id) {
          console.log("item.Prod_code === id", item.Prod_code, id);

          return {
            ...item,
            [field]: value,
            ...(field === "itemCode" && { isSelectedItemCodeCorrect: false }), // Set isSelectedItemCodeCorrect to false when itemCode changes
          };
        }
        return item;
      } else {
        if (item.id === id) {
          return {
            ...item,
            [field]: value,
            ...(field === "itemCode" && { isSelectedItemCodeCorrect: false }), // Set isSelectedItemCodeCorrect to false when itemCode changes
          };
        }
        return item;
      }
    });

    // Set the updated productEntries array to state
    setProductsInQuotation(newArray);
  };

  const fetchItemDetails = async (itemCode, rowId) => {
    console.log(`Fetching details for Item Code: ${itemCode}`); // Log item code before fetching
    if (!itemCode) return;

    setTimeout(async () => {
      try {
        const response = await fetch(
          `${apiPaths_from_local_storage[0].API_CONFIG}/api/Search_Items/${company_code_from_local_storage}/Sitem/${itemCode}`
        );

        console.log("API response status:", response.status); // Log API response status

        const data = await response.json();
        console.log("API response data:", data); // Log response data
        setProductData(data);
      } catch (error) {
        console.error("Error fetching item details:", error);
      }
    }, 500); // Delay API call to avoid excessive requests
  };

  const selectProduct = (setProductCode) => {
    console.log("index of select product", setProductCode);
    setIsSubmittingForm(true);

    const isDuplicate = productEntries.some(
      (product) => product.itemCode === setProductCode
    );
    if (isDuplicate) {
      // alert('this item already exists')
      setDuplicateItemCodeSnackbar(true);
      setIsSubmittingForm(false);
      return;
    }

    const selectedProduct = productData.find(
      (product) => product.Code === setProductCode
    );

    if (selectedProduct) {
      setProductsInQuotation((prevEntries) =>
        prevEntries.map((entry) =>
          entry.id === currentProductEntryRowId
            ? {
                ...entry,
                itemCode: selectedProduct.Code,
                itemDescription: selectedProduct.Description,
                itemImage: selectedProduct.Imagepath,
                // itemUnit: selectedProduct.unit,
                itemUnit: "PCS",
                itemCurrentStock: selectedProduct.Stick, // Adjust according to your product data
                itemPrice: selectedProduct.SelPrice, // Adjust according to your product data
                itemAmount: selectedProduct.SelPrice * entry.itemQuantity, // Example calculation
                isSelectedItemCodeCorrect: true, // Example calculation
              }
            : entry
        )
      );
    }
    setIsDropdownOpen(false);
    setProductData(null);
  };

  const clearProductsList = () => {
    localStorage.removeItem("currentEdittingProductsList");
    setProductData([]);
  };

  const handleCloseSubmitSnackbar = () => {
    setOpenSubmitSnackbar(false);
    setDuplicateItemCodeSnackbar(false);
  };

  useEffect(() => {
    if (productsInQuotationState?.length === 0) {
      // clearProductsList()
      localStorage.removeItem("currentEdittingProductsList");
    }
    console.log("productsInQuotationState", productsInQuotationState);

    if (productsInQuotationState) {
      localStorage.setItem(
        "currentEdittingProductsList",
        JSON.stringify(productsInQuotationState)
      );
      const itemCodeInProducts = productsInQuotationState?.map(
        (itemcodeProd) => itemcodeProd.itemCode
      );
      // console.log("itemCodeInProducts:", itemCodeInProducts);

      // Check if any item has isSelectedItemCodeCorrect as false
      const hasIncorrectItemCode = productsInQuotationState?.some(
        (item) => !item.isSelectedItemCodeCorrect
      );

      if (hasIncorrectItemCode) {
        setIsSubmittingForm(false);
      }

      if (vat === "vatApplied") {
        console.log("inside vatapplied >>", vat);

        console.log("setvatvalue 4");
        setVatValue(
          (productsInQuotationState
            ?.filter((item) => {
              if (item.itemCustRef === "OPT" || item.itemCustRef === "OPTION") {
                return false;
              } else {
                return true;
              }
            })
            .reduce((acc, curr) => {
              if (curr.Lead_ID) {
                return acc + curr.Prod_Qty * curr.Prod_Price;
              } else {
                return acc + curr.itemQuantity * curr.itemPrice;
              }
            }, 0) -
            discountValue) *
            Number(0.05)
        );
      } else if (vat === "noVat") {
        console.log("inside noVat", vat);
        console.log("setvatvalue 5");
        setVatValue(0);
      } else {
        console.log("Unexpected vatFromSaleTab value:", vat);
      }
    }
  }, [productsInQuotationState]);

  useEffect(() => {
    if (vat === "vatApplied") {
      console.log("setvatvalue 6");
      setVatValue(
        (productsInQuotationState
          ?.filter((item) => {
            if (item.itemCustRef === "OPT" || item.itemCustRef === "OPTION") {
              return false;
            } else {
              return true;
            }
          })
          .reduce((acc, curr) => {
            if (curr.Lead_ID) {
              return (acc = acc + curr.Prod_Qty * curr.Prod_Price);
            } else {
              return (acc = acc + curr.itemQuantity * curr.itemPrice);
            }
          }, 0) -
          discountValue) *
          0.05
      );
      setVatIncluded(true);
    } else if (vat === "noVat") {
      console.log("setvatvalue 6");
      setVatValue(0);
      setVatIncluded(false);
    } else {
    }
  }, [vat]);

  useEffect(() => {
    if (discountValue) {
      if (vat === "vatApplied") {
        console.log("setvatvalue 7");
        setVatValue(
          (productsInQuotationState
            ?.filter((item) => {
              if (item.itemCustRef === "OPT" || item.itemCustRef === "OPTION") {
                return false;
              } else {
                return true;
              }
            })
            .reduce((acc, curr) => {
              if (curr.Lead_ID) {
                return acc + curr.Prod_Qty * curr.Prod_Price;
              } else {
                return acc + curr.itemQuantity * curr.itemPrice;
              }
            }, 0) -
            discountValue) *
            Number(0.05)
        );
      } else {
        console.log("setvatvalue 8");
        setVatValue(
          (productsInQuotationState
            ?.filter((item) => {
              if (item.itemCustRef === "OPT" || item.itemCustRef === "OPTION") {
                return false;
              } else {
                return true;
              }
            })
            .reduce((acc, curr) => {
              if (curr.Lead_ID) {
                return acc + curr.Prod_Qty * curr.Prod_Price;
              } else {
                return acc + curr.itemQuantity * curr.itemPrice;
              }
            }, 0) -
            discountValue) *
            0
        );
      }
    }
  }, [discountValue]);

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleDeleteSelected = (e) => {
    e.preventDefault();
    console.log("productToDelete::", e.target.value);

    const remainingRows = productEntries.filter(
      (entry) => !selectedRows.includes(entry.id)
    );

    // Ensure at least one row exists
    if (remainingRows.length === 0) {
      remainingRows.push({ ...defaultRow, id: Date.now() });
    }

    setProductEntries(remainingRows);
    setSelectedRows([]);
  };

  const productEntryInAllEntries = (productEntryTimeline) => {
    console.log("productEntryTimeline from all entries:", productEntryTimeline);

    // Ensure productEntryTimeline has data and extract the first entry
    const productFormData =
      productEntryTimeline && productEntryTimeline[0]
        ? productEntryTimeline[0]
        : {};

    console.log("productFormData:", productFormData);

    const isProductAdded = !!(
      productFormData.itemCode ||
      productFormData.itemDescription ||
      productFormData.itemUnit ||
      productFormData.itemCurrentStock ||
      productFormData.itemQuantity ||
      productFormData.itemPrice ||
      productFormData.itemAmount
    );

    console.log("isProductAdded ::  :", isProductAdded);

    // setFormData((prevFormData) => ({
    //   ...prevFormData,
    //   isItemAdded: isProductAdded,
    //   itemCode: productFormData.itemCode || "",
    //   itemDescription: productFormData.itemDescription || "",
    //   itemUnit: productFormData.itemUnit || "",
    //   itemCurrentStock: productFormData.itemCurrentStock || "",
    //   itemQuantity: productFormData.itemQuantity || "",
    //   itemPrice: productFormData.itemPrice || "",
    //   itemAmount: productFormData.itemAmount || "",
    // }));
  };

  useEffect(() => {
    console.log(
      "productsInQuotation :",
      productsInQuotationState,
      currentProductEntryRowId
    );
  }, [productsInQuotationState, currentProductEntryRowId]);

  useEffect(() => {
    console.log("currentProductEntryRowId", currentProductEntryRowId);
  }, [currentProductEntryRowId]);

  const sendForApprovalClicked = () => {
    let newArray = productsInQuotationState?.map((item) => {
      return { ...item, area_code: "For Approval" };
    });

    // Set the updated productEntries array to state
    setProductsInQuotation(newArray);
  };

  const callApisAgainInQuoteLead = (selectedLeadFromSaleTab) => {
    console.log("selectedLeadFromSaleTab", selectedLeadFromSaleTab);
    checkingForQuotation(selectedLeadFromSaleTab);
  };

  const giveNextActionArrayToParent = (nextActionArray) => {
    setNextActionArrayInParent(nextActionArray);
  };

  const updatePaymentTerms = (e) => {
    console.log(" typed textarea ", e.target.value);

    setPaymentState(e.target.value);
  };

  const getTemplatelist = () => {
    setIsCallingTemplateListApi(true);

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/Proposal/${company_code_from_local_storage}/TERMSTEMPLATELIST/-/-`;

    axios
      .get(apiUrl)
      .then((res) => {
        setIsCallingTemplateListApi(false);

        setTermsTemplatelist(res.data);
      })
      .catch((err) => {
        setIsCallingTemplateListApi(false);

        setTermsTemplatelist(null);
      });
  };

  const getTermsTemplateDetails = (itemCodeFromClick) => {
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/Proposal/${company_code_from_local_storage}/TERMSTEMPLATESINGLE/${itemCodeFromClick}/-`;

    axios
      .get(apiUrl)
      .then((res) => {
        let newArray = res.data.filter((itemFilter) => {
          return itemCodeFromClick === itemFilter.mastercode;
        });

        setPaymentState(newArray[0].description ? newArray[0].description : "");

        setShowHideTemplateList(false);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    if (showHideTemplateList) {
      getTemplatelist();
    } else {
      setTermsTemplatelist(null);
    }
  }, [showHideTemplateList]);

  const saveToTermsTemplate = () => {
    setIsCallingAddToTemplateListApi(true);

    let objectToSend = [
      {
        CmpCode: company_code_from_local_storage,
        mode: "ENTRY",
        mastercode: templatename,
        description: paymentState,
      },
    ];

    console.log("objectToSend to terms ", objectToSend);

    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/TermsTemplate`;

    axios
      .post(apiUrl, objectToSend, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setIsCallingAddToTemplateListApi(false);

        if (res.data.result === "Saved") {
          alert("templated added successfully");

          setShowAddToTemplateForm(false);
          setTemplateName("");
        } else {
          alert(
            "something went wrong, please enter different name or please try later"
          );
        }
      })
      .catch((err) => {
        setIsCallingAddToTemplateListApi(false);
        alert("something went wrong please try later");
      });
  };

  return (
    <ThemeProvider theme={theme}>
      <div
        id="quotation-content"
        className=" quotation-container    px-4 mb-4 rounded-md  max-h-[100vh] overflow-y-auto scrollbar-thin"
      >
        {showPDFDialogBox && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-4 rounded-lg shadow-lg max-w-md w-full mx-4">
              <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">
                Quotation Data Saved Successfully!
              </h2>
              <div className="flex justify-center space-x-4">
                {/* <button
                                    onClick={navigateToPDF}
                                    className="px-4 py-2 rounded-lg bg-blue-500 text-white hover:bg-blue-600 transition duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                >
                                    View PDF
                                </button> */}
                <button
                  onClick={() => {
                    setShowPDFDialogBox(false);
                    checkingForQuotation(selectedLead.Prop_No);
                  }}
                  className="px-4 py-2 rounded-lg bg-gray-500 text-white hover:bg-gray-600 transition duration-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        {isQuotationRoute && (
          <div
            role="presentation"
            className="bg-gray-100 pl-4 py-3 rounded-md shadow w-80"
          >
            <Breadcrumbs
              aria-label="breadcrumb"
              className="flex items-center space-x-0 text-gray-600 "
            >
              {/* Qualified Leads Breadcrumb */}
              <Link
                className="flex items-center space-x-1 text-gray-700 hover:text-blue-600"
                underline="hover"
                color="inherit"
                component={RouterLink}
                to="/qualifiedLeadsTable"
              >
                <span className="material-icons text-sm">home</span>
                <h2 className="text-base font-medium truncate">
                  Qualified Leads
                </h2>
              </Link>

              {/* Quotation Breadcrumb (conditionally rendered) */}
              {isQuotationRoute && (
                <Link
                  className="flex items-center space-x-1 text-gray-700 hover:text-blue-600 "
                  underline="hover"
                  color="inherit"
                  component={RouterLink}
                  to={location.pathname}
                >
                  <span className="material-icons text-sm">receipt</span>
                  <h2 className="text-base font-medium truncate">Quotation</h2>
                </Link>
              )}
            </Breadcrumbs>
          </div>
        )}

        {productsInQuotationState?.some(
          (prod) => !prod.isSelectedItemCodeCorrect && prod.itemCode?.length > 0
        ) ? (
          <Snackbar
            open={openSnackbar}
            autoHideDuration={3000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <MuiAlert
              onClose={handleCloseSnackbar}
              severity="error"
              sx={{ width: "100%" }}
            >
              {`Item Code is not Correct at row ${errorRow} `}
            </MuiAlert>
          </Snackbar>
        ) : (
          <Snackbar
            open={openSubmitSnackbar}
            autoHideDuration={3000}
            onClose={handleCloseSubmitSnackbar}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <MuiAlert
              onClose={handleCloseSnackbar}
              severity="success"
              sx={{ width: "100%" }}
            >
              Form Submitted Successfully!
            </MuiAlert>
          </Snackbar>
        )}

        {duplicateItemCodeSnackbar && (
          <Snackbar
            open={duplicateItemCodeSnackbar}
            autoHideDuration={3000}
            onClose={handleCloseSubmitSnackbar}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <MuiAlert
              onClose={handleCloseSnackbar}
              severity="error"
              sx={{ width: "100%" }}
            >
              This item is already selected. Duplicate entries are not allowed!
            </MuiAlert>
          </Snackbar>
        )}

        <div className="flex gap-4 justify-between items-center">
          {/* Tabs Section */}
          <Box>
            <Tabs
              value={selectedTab1}
              onChange={handleTab1Change}
              textColor="primary"
              indicatorColor="primary"
            >
              <Tab label="Sale" />
              <Tab label="Customer Details" />
              <Tab label="Customer History" />
              {/* <Tab label="History Details" /> */}
            </Tabs>
          </Box>

          <div className="flex items-center gap-4  p-4 rounded-md">
            <div>
              <p className="text-sm text-gray-600">Amount</p>
              <p className="text-xl font-semibold">
                {productsInQuotationState
                  ? productsInQuotationState
                      ?.filter((item) => {
                        if (
                          item.itemCustRef === "OPT" ||
                          item.itemCustRef === "OPTION"
                        ) {
                          return false;
                        } else {
                          return true;
                        }
                      })
                      .reduce((acc, curr) => {
                        if (curr.Lead_ID) {
                          return (acc = acc + curr.Prod_Qty * curr.Prod_Price);
                        } else {
                          return (acc =
                            acc + curr.itemQuantity * curr.itemPrice);
                        }
                      }, 0) -
                    discountValue +
                    vatValue
                  : "--"}
              </p>
            </div>

            {console.log("nx >> ", productsInQuotationState, selectedLead)}
            {productsInQuotationState &&
              productsInQuotationState[0]?.area_code && (
                <button
                  onClick={navigateToPDF}
                  className="px-4 py-2 rounded-lg bg-blue-500 text-white hover:bg-blue-600 transition duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                >
                  View PDF
                </button>
              )}

            <button
              onClick={handleRedirect}
              className="px-4 py-1 rounded-md text-red-500 border border-red-500 bg-white hover:bg-red-100 transition"
            >
              Cancel
            </button>

            <button
              className="bg-pink-500 hover:bg-pink-600 text-white px-2 py-1 rounded"
              onClick={onQuotationList}
            >
              Quotation List
            </button>
          </div>

          {/* </div> */}
        </div>
        <Box
          className=""
          sx={{
            p: 2,
            mt: 0,
            border: "1px solid #ccc",
            borderRadius: "4px",
            backgroundColor: "#fff",
          }}
        >
          {selectedTab1 === 0 && (
            <SalesTab
              mode="quotation"
              selectedLead={selectedLead}
              customerType={customerType}
              onCustomerTypeChange={handleCustomerTypeChange}
              sendForApprovalClicked={sendForApprovalClicked}
              productsInQuotationState={productsInQuotationState}
              vat={vat}
              setVat={setVat}
              callApisAgainInQuoteLead={callApisAgainInQuoteLead}
              giveNextActionArrayToParent={giveNextActionArrayToParent}
              setTypedAccountFromChild={setTypedAccountFromChild}
              setTypedCustomerNameFromChild={setTypedCustomerNameFromChild}
              setTypedProjectNameFromChild={setTypedProjectNameFromChild}
              typedAccountFromChild={typedAccountFromChild}
              typedCustomerNameFromChild={typedCustomerNameFromChild}
              typedProjectNameFromChild={typedProjectNameFromChild}
            />
          )}
          {selectedTab1 === 1 && (
            <CustomerDetailsTab
              selectedLead={selectedLead}
              subject={customerSubject} // Pass state variable
              setCustomerSubject={setCustomerSubject} // Pass setter function
              customerTRN={customerTRN} // Pass state variable
              setCustomerTRN={setCustomerTRN} // Pass setter function
            />
          )}
          {selectedTab1 === 2 && <OtherDetailsTab />}
          {selectedTab1 === 3 && <OtherDetailsTab />}
        </Box>

        {/* <Box
          sx={{
            height: 300,
            width: "100%",
            marginTop: "1rem",
            border: "1px solid #ccc",
          }}
        >
          <DataGrid
            rows={leadItems}
            columns={columns}
            getRowId={(row) => row.id}
            // checkboxSelection
            disableSelectionOnClick
            hideFooterPagination
            hideFooter
            density="compact"
            onRowSelectionModelChange={(newSelection) => {
              setSelectedProductRows(newSelection); // ✅ Updates selected rows manually
            }}
            rowSelectionModel={selectedRows} // ✅ Ensures controlled selection
          />
        </Box> */}

        <ProductsInQuotation
          // lead={formData.lead}
          productEntryInAllEntries={productEntryInAllEntries}
          clearProductsList={clearProductsList}
          productEntries={productEntries}
          productsInQuotationState={productsInQuotationState}
          setProductEntries={setProductEntries}
          handleAddRow={handleAddRow}
          handleDeleteSelected={handleDeleteSelected}
          handleInputChange={handleInputChange}
          selectProduct={selectProduct}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          currentProductEntryRowId={currentProductEntryRowId}
          productData={productData}
          setCurrentF2ItemForSearchPopup={setCurrentF2ItemForSearchPopup}
        />

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "30%",
            marginLeft: "auto",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p>
              Amount{" "}
              {console.log(
                "productsInQuotationState in amount view",
                productsInQuotationState
              )}{" "}
            </p>
            <span style={{ fontWeight: "bold" }}>
              {productsInQuotationState
                ?.filter((item) => {
                  if (
                    item.itemCustRef === "OPT" ||
                    item.itemCustRef === "OPTION"
                  ) {
                    return false;
                  } else {
                    return true;
                  }
                })
                .reduce((acc, curr) => {
                  if (curr.Lead_ID) {
                    return (acc = acc + curr.Prod_Qty * curr.Prod_Price);
                  } else {
                    return (acc = acc + curr.itemQuantity * curr.itemPrice);
                  }
                }, 0)}
            </span>
          </div>

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p style={{ marginRight: "30px" }}>Discount</p>
            <TextField
              width="50px"
              value={discountValue}
              size="small"
              variant="standard"
              type="number"
              inputProps={{ min: 0, style: { textAlign: "right" } }}
              onChange={(e) => setDiscountValue(e.target.value)}
            />
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p>
              Taxable Amount{" "}
              {console.log(
                "productsInQuotationState taxable amount ",
                productsInQuotationState
              )}
            </p>
            <span style={{ fontWeight: "bold" }}>
              {isNaN(
                productsInQuotationState
                  ?.filter((item) => {
                    if (
                      item.itemCustRef === "OPT" ||
                      item.itemCustRef === "OPTION"
                    ) {
                      return false;
                    } else {
                      return true;
                    }
                  })
                  .reduce((acc, curr) => {
                    return acc + curr.itemQuantity * curr.itemPrice;
                  }, 0) - (discountValue ? discountValue : 0)
              )
                ? "--"
                : productsInQuotationState
                    ?.filter((item) => {
                      if (
                        item.itemCustRef === "OPT" ||
                        item.itemCustRef === "OPTION"
                      ) {
                        return false;
                      } else {
                        return true;
                      }
                    })
                    .reduce((acc, curr) => {
                      return acc + curr.itemQuantity * curr.itemPrice;
                    }, 0) - (discountValue ? discountValue : 0)}
            </span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p>Vat % </p>
            <span style={{ fontWeight: "bold" }}>{vatValue === 0 ? 0 : 5}</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p>Vat Amount</p>
            <span style={{ fontWeight: "bold" }}>
              {vatValue ? parseFloat(vatValue).toFixed(2) : "--"}
            </span>{" "}
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p>Total Amount </p>
            <span style={{ fontWeight: "bold" }}>
              {productsInQuotationState
                ? parseFloat(
                    productsInQuotationState
                      ?.filter((item) => {
                        if (
                          item.itemCustRef === "OPT" ||
                          item.itemCustRef === "OPTION"
                        ) {
                          return false;
                        } else {
                          return true;
                        }
                      })
                      .reduce((acc, curr) => {
                        if (curr.Lead_ID) {
                          return (acc = acc + curr.Prod_Qty * curr.Prod_Price);
                        } else {
                          return (acc =
                            acc + curr.itemQuantity * curr.itemPrice);
                        }
                      }, 0) -
                      discountValue +
                      (!isNaN(vatValue) ? vatValue : 0)
                  ).toFixed(2)
                : "--"}
            </span>{" "}
          </div>
        </div>

        <Box className="flex justify-between items-center gap-4">
          <div>
            <Tabs
              value={selectedTab2}
              onChange={handleTab2Change}
              textColor="primary"
              indicatorColor="primary"
            >
              {/* <Tab label="Delivery" />
                            <Tab label="Payment" />
                            <Tab label="Validity" />
                            <Tab label="Remarks" /> */}
              <Tab label="Terms & Conditions" />
            </Tabs>
          </div>
          <div className="flex items-center space-x-4 justify-center">
            {/* Currency Selector */}
            <div className="mb-0   flex items-center space-x-4">
              <TextField
                select
                label="Currency"
                name="currency"
                value={currency} // Separate state for currency
                // value={formData.currency || ""} // Separate state for currency
                onChange={handleCurrency}
                variant="standard"
                sx={{
                  width: "100px",
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                }}
              >
                <MenuItem value="AED">AED</MenuItem>
                <MenuItem value="USD">USD</MenuItem>
                <MenuItem value="EUR">EUR</MenuItem>
                <MenuItem value="GBP">GBP</MenuItem>
                <MenuItem value="INR">INR</MenuItem>
                <MenuItem value="JPY">JPY</MenuItem>
                <MenuItem value="AUD">AUD</MenuItem>
              </TextField>

              {/* Booked Amount */}
              <TextField
                label="Amount"
                name="bookedAmount"
                type="number"
                // value={formData.bookedAmount || ""} // Separate state for booked amount
                value={currencyAmount} // Separate state for booked amount
                onChange={handleCurrencyAmount}
                fullWidth
                variant="standard"
                InputProps={{
                  inputProps: { min: 0 }, // Prevent negative amounts
                }}
                sx={{
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                }}
              />
            </div>

            <div>
              <FormControlLabel
                control={
                  <Switch
                    checked={vatIncluded}
                    onChange={handleToggle}
                    color="primary"
                  />
                }
                label="Include VAT"
              />
              <TextField
                label="VAT"
                value={parseFloat(vatValue).toFixed(2)}
                size="small"
                variant="standard"
                InputProps={{
                  readOnly: true, // Make the field read-only to reflect the VAT value
                }}
              />
            </div>
          </div>

          {/* Tabs Section */}
          {/* <Box> */}
        </Box>
        <Box
          sx={{
            p: 2,
            mt: 2,
            border: "1px solid #ccc",
            borderRadius: "4px",
            backgroundColor: "#fff",
          }}
        >
          {/* {selectedTab2 === 0 && (
                        <div>Delivery details: Delivered within 7 business days.</div>
                    )}
                    {selectedTab2 === 1 && (
                        <div>Payment terms: 50% advance, 50% upon delivery.</div>
                    )}
                    {selectedTab2 === 2 && (
                        <div>Validity: Quotation valid for 30 days from issuance.</div>
                    )}
                    {selectedTab2 === 3 && (
                        <div>
                            Remarks: Please ensure all details are accurate before confirming.
                        </div>
                    )} */}
          {selectedTab2 === 0 && (
            <div>
              <div className="flex">
                <div style={{ position: "relative" }}>
                  <button
                    className="px-4 py-2 rounded-md text-sm  text-white bg-blue-500 hover:bg-gray-800 transition"
                    onClick={() => setShowHideTemplateList((prev) => !prev)}
                  >
                    Terms template List
                  </button>

                  <div
                    style={{
                      position: "absolute",
                      top: "40px",
                      width: "300px",
                      borderWidth: "1px",
                      backgroundColor: "#ffffff",
                    }}
                  >
                    {isCallingTemplateListApi && (
                      <div role="status">
                        <svg
                          aria-hidden="true"
                          class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentFill"
                          />
                        </svg>
                      </div>
                    )}
                    {termsTemplatelist?.map((item) => {
                      return (
                        <div
                          className="p-2"
                          onClick={() =>
                            getTermsTemplateDetails(item.mastercode)
                          }
                        >
                          <p>{item.mastercode}</p>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <button
                  className="ms-2 mb-2 px-4 py-2 rounded-md text-sm  text-white bg-blue-500 hover:bg-gray-800 transition"
                  onClick={() => setShowAddToTemplateForm((prev) => !prev)}
                >
                  Add To Template
                </button>
              </div>
              {showAddToTemplateForm && (
                <div className="mt-2">
                  {isCallingAddToTemplateListApi && (
                    <div role="status">
                      <svg
                        aria-hidden="true"
                        class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                    </div>
                  )}
                  <input
                    placeholder="enter template name"
                    onChange={(e) => setTemplateName(e.target.value)}
                  ></input>
                  <button
                    className="ms-2 px-4 py-2 rounded-md text-sm  text-white bg-blue-500 hover:bg-gray-800 transition"
                    onClick={() => saveToTermsTemplate()}
                  >
                    Add
                  </button>
                </div>
              )}
              <textarea
                className="w-full h-40"
                value={paymentState}
                onChange={(e) => updatePaymentTerms(e)}
              ></textarea>
            </div>
          )}
        </Box>
        {/* </Box> */}

        <div className="p-6 flex justify-center items-center ">
          <button
            // onClick={togglePopup}
            onClick={handleSaveQuotation}
            className="px-4 py-2 rounded-md w-[200px] text-white bg-black hover:bg-gray-800 transition"
          >
            Save
          </button>
        </div>

        <ImageModal
          modalImage={modalImage}
          openModal={openModal}
          onClose={() => setOpenModal(false)} // Close modal handler
          onImageChange={(e) => {
            const file = e.target.files[0];
            if (file) {
              const newImageUrl = URL.createObjectURL(file);
              setModalImage(newImageUrl); // Update the modal image

              // Update the product image in the products state
              setProducts((prevProducts) =>
                prevProducts.map((product) =>
                  product.image === modalImage // Find the product with the matching image
                    ? { ...product, image: newImageUrl } // Update its image
                    : product
                )
              );
            }
          }}
        />
      </div>
    </ThemeProvider>
  );
};

export default QuotationComponent;
